import { Box } from '@material-ui/core';
import { IntegrationType, LenderName, SignatureUrls } from '@nemuru-eng/js-api-client';

import { Icon } from '@/components/shared/components/Icon';
import { StandardButton } from '@/components/shared/components/StandardButton';
import { Text } from '@/components/shared/components/Text';

interface RedirectSignatureProps {
  signatureUrls: SignatureUrls;
  lenderName: LenderName;
  requiresResignature?: boolean;
  disabled?: boolean;
}

export const RedirectSignature = ({
  signatureUrls,
  lenderName,
  requiresResignature,
  disabled,
}: RedirectSignatureProps) => {
  const { url, coBorrowerUrl, integrationType } = signatureUrls;

  if (!url || !integrationType || ![IntegrationType.REDIRECT, IntegrationType.EMBEDDED].includes(integrationType)) {
    return null;
  }

  const onSign = (url: string) => {
    window.open(url, '_blank');
  };

  return (
    <Box width={'fit-content'} display="flex" justifyContent="flex-end" flexShrink={0} gridGap={8}>
      <StandardButton
        main
        disabled={!url || disabled}
        size="small"
        onClick={() => onSign(url)}
        endIcon={<Icon size={16}>open_in_new</Icon>}
      >
        <Text
          tId={
            requiresResignature
              ? 'RESIGNATURE_CONTRACT'
              : lenderName === LenderName.SANTANDER_CONSUMER
              ? 'COMPLETE'
              : coBorrowerUrl
              ? 'SIGN_BORROWER_CONTRACT'
              : 'SIGN_CONTRACT'
          }
        />
      </StandardButton>
      {coBorrowerUrl && (
        <StandardButton
          main
          size="small"
          disabled={disabled}
          onClick={() => onSign(coBorrowerUrl)}
          endIcon={<Icon size={16}>open_in_new</Icon>}
        >
          <Text tId={'SIGN_CO_BORROWER_CONTRACT'} />
        </StandardButton>
      )}
    </Box>
  );
};
